import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=6ac190b8&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
import style0 from "./Hero.vue?vue&type=style&index=0&id=6ac190b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac190b8",
  null
  
)

export default component.exports